export interface Country {
  isoCode: string;
  name: string;
  nativeName: string;
  dialCode: string;
}

export const COUNTRIES: Country[] = [
  { isoCode: 'AF', name: 'Afghanistan', nativeName: 'افغانستان', dialCode: '93' },
  { isoCode: 'AL', name: 'Albania', nativeName: 'Shqipëria', dialCode: '355' },
  { isoCode: 'DZ', name: 'Algeria', nativeName: 'الجزائر', dialCode: '213' },
  { isoCode: 'AS', name: 'American Samoa', nativeName: 'American Samoa', dialCode: '1684' },
  { isoCode: 'AD', name: 'Andorra', nativeName: 'Andorra', dialCode: '376' },
  { isoCode: 'AO', name: 'Angola', nativeName: 'Angola', dialCode: '244' },
  { isoCode: 'AI', name: 'Anguilla', nativeName: 'Anguilla', dialCode: '1264' },
  {
    isoCode: 'AG',
    name: 'Antigua and Barbuda',
    nativeName: 'Antigua and Barbuda',
    dialCode: '1268'
  },
  { isoCode: 'AR', name: 'Argentina', nativeName: 'Argentina', dialCode: '54' },
  { isoCode: 'AM', name: 'Armenia', nativeName: 'Հայաստան', dialCode: '374' },
  { isoCode: 'AW', name: 'Aruba', nativeName: 'Aruba', dialCode: '297' },
  { isoCode: 'AU', name: 'Australia', nativeName: 'Australia', dialCode: '61' },
  { isoCode: 'AT', name: 'Austria', nativeName: 'Österreich', dialCode: '43' },
  { isoCode: 'AZ', name: 'Azerbaijan', nativeName: 'Azərbaycan', dialCode: '994' },
  { isoCode: 'BS', name: 'Bahamas', nativeName: 'Bahamas', dialCode: '1242' },
  { isoCode: 'BH', name: 'Bahrain', nativeName: 'البحرين', dialCode: '973' },
  { isoCode: 'BD', name: 'Bangladesh', nativeName: 'বাংলাদেশ', dialCode: '880' },
  { isoCode: 'BB', name: 'Barbados', nativeName: 'Barbados', dialCode: '1246' },
  { isoCode: 'BY', name: 'Belarus', nativeName: 'Беларусь', dialCode: '375' },
  { isoCode: 'BE', name: 'Belgium', nativeName: 'België', dialCode: '32' },
  { isoCode: 'BZ', name: 'Belize', nativeName: 'Belize', dialCode: '501' },
  { isoCode: 'BJ', name: 'Benin', nativeName: 'Bénin', dialCode: '229' },
  { isoCode: 'BM', name: 'Bermuda', nativeName: 'Bermuda', dialCode: '1441' },
  { isoCode: 'BT', name: 'Bhutan', nativeName: 'འབྲུག', dialCode: '975' },
  { isoCode: 'BO', name: 'Bolivia', nativeName: 'Bolivia', dialCode: '591' },
  {
    isoCode: 'BA',
    name: 'Bosnia and Herzegovina',
    nativeName: 'Bosna i Hercegovina',
    dialCode: '387'
  },
  { isoCode: 'BW', name: 'Botswana', nativeName: 'Botswana', dialCode: '267' },
  { isoCode: 'BR', name: 'Brazil', nativeName: 'Brasil', dialCode: '55' },
  {
    isoCode: 'IO',
    name: 'British Indian Ocean Territory',
    nativeName: 'British Indian Ocean Territory',
    dialCode: '246'
  },
  {
    isoCode: 'VG',
    name: 'British Virgin Islands',
    nativeName: 'British Virgin Islands',
    dialCode: '1284'
  },
  { isoCode: 'BN', name: 'Brunei', nativeName: 'Brunei', dialCode: '673' },
  { isoCode: 'BG', name: 'Bulgaria', nativeName: 'България', dialCode: '359' },
  { isoCode: 'BF', name: 'Burkina Faso', nativeName: 'Burkina Faso', dialCode: '226' },
  { isoCode: 'BI', name: 'Burundi', nativeName: 'Burundi', dialCode: '257' },
  { isoCode: 'KH', name: 'Cambodia', nativeName: 'កម្ពុជា', dialCode: '855' },
  { isoCode: 'CM', name: 'Cameroon', nativeName: 'Cameroun', dialCode: '237' },
  { isoCode: 'CA', name: 'Canada', nativeName: 'Canada', dialCode: '1' },
  { isoCode: 'CV', name: 'Cape Verde', nativeName: 'Cabo Verde', dialCode: '238' },
  {
    isoCode: 'BQ',
    name: 'Caribbean Netherlands',
    nativeName: 'Caribisch Nederland',
    dialCode: '599'
  },
  { isoCode: 'KY', name: 'Cayman Islands', nativeName: 'Cayman Islands', dialCode: '1345' },
  {
    isoCode: 'CF',
    name: 'Central African Republic',
    nativeName: 'République centrafricaine',
    dialCode: '236'
  },
  { isoCode: 'TD', name: 'Chad', nativeName: 'تشاد', dialCode: '235' },
  { isoCode: 'CL', name: 'Chile', nativeName: 'Chile', dialCode: '56' },
  { isoCode: 'CN', name: 'China', nativeName: '中国', dialCode: '86' },
  { isoCode: 'CX', name: 'Christmas Island', nativeName: 'Christmas Island', dialCode: '61' },
  { isoCode: 'CC', name: 'Cocos Islands', nativeName: 'Cocos Islands', dialCode: '61' },
  { isoCode: 'CO', name: 'Colombia', nativeName: 'Colombia', dialCode: '57' },
  { isoCode: 'KM', name: 'Comoros', nativeName: 'جزر القمر', dialCode: '269' },
  { isoCode: 'CG', name: 'Congo', nativeName: 'Congo', dialCode: '242' },
  {
    isoCode: 'CD',
    name: 'Congo (DRC)',
    nativeName: 'République démocratique du Congo',
    dialCode: '243'
  },
  { isoCode: 'CK', name: 'Cook Islands', nativeName: 'Cook Islands', dialCode: '682' },
  { isoCode: 'CR', name: 'Costa Rica', nativeName: 'Costa Rica', dialCode: '506' },
  { isoCode: 'HR', name: 'Croatia', nativeName: 'Hrvatska', dialCode: '385' },
  { isoCode: 'CU', name: 'Cuba', nativeName: 'Cuba', dialCode: '53' },
  { isoCode: 'CW', name: 'Curaçao', nativeName: 'Curaçao', dialCode: '599' },
  { isoCode: 'CY', name: 'Cyprus', nativeName: 'Κύπρος', dialCode: '357' },
  { isoCode: 'CZ', name: 'Czech Republic', nativeName: 'Česká republika', dialCode: '420' },
  { isoCode: 'CI', name: "Côte d'Ivoire", nativeName: "Côte d'Ivoire", dialCode: '225' },
  { isoCode: 'DK', name: 'Denmark', nativeName: 'Danmark', dialCode: '45' },
  { isoCode: 'DJ', name: 'Djibouti', nativeName: 'Djibouti', dialCode: '253' },
  { isoCode: 'DM', name: 'Dominica', nativeName: 'Dominica', dialCode: '1767' },
  { isoCode: 'DO', name: 'Dominican Republic', nativeName: 'República Dominicana', dialCode: '1' },
  { isoCode: 'EC', name: 'Ecuador', nativeName: 'Ecuador', dialCode: '593' },
  { isoCode: 'EG', name: 'Egypt', nativeName: 'مصر', dialCode: '20' },
  { isoCode: 'SV', name: 'El Salvador', nativeName: 'El Salvador', dialCode: '503' },
  { isoCode: 'GQ', name: 'Equatorial Guinea', nativeName: 'Guinea Ecuatorial', dialCode: '240' },
  { isoCode: 'ER', name: 'Eritrea', nativeName: 'ኤርትራ', dialCode: '291' },
  { isoCode: 'EE', name: 'Estonia', nativeName: 'Eesti', dialCode: '372' },
  { isoCode: 'SZ', name: 'Eswatini', nativeName: 'Eswatini', dialCode: '268' },
  { isoCode: 'ET', name: 'Ethiopia', nativeName: 'ኢትዮጵያ', dialCode: '251' },
  { isoCode: 'FK', name: 'Falkland Islands', nativeName: 'Falkland Islands', dialCode: '500' },
  { isoCode: 'FO', name: 'Faroe Islands', nativeName: 'Føroyar', dialCode: '298' },
  { isoCode: 'FJ', name: 'Fiji', nativeName: 'Fiji', dialCode: '679' },
  { isoCode: 'FI', name: 'Finland', nativeName: 'Suomi', dialCode: '358' },
  { isoCode: 'FR', name: 'France', nativeName: 'France', dialCode: '33' },
  { isoCode: 'GF', name: 'French Guiana', nativeName: 'Guyane française', dialCode: '594' },
  { isoCode: 'PF', name: 'French Polynesia', nativeName: 'Polynésie française', dialCode: '689' },
  { isoCode: 'GA', name: 'Gabon', nativeName: 'Gabon', dialCode: '241' },
  { isoCode: 'GM', name: 'Gambia', nativeName: 'Gambia', dialCode: '220' },
  { isoCode: 'GE', name: 'Georgia', nativeName: 'საქართველო', dialCode: '995' },
  { isoCode: 'DE', name: 'Germany', nativeName: 'Deutschland', dialCode: '49' },
  { isoCode: 'GH', name: 'Ghana', nativeName: 'Ghana', dialCode: '233' },
  { isoCode: 'GI', name: 'Gibraltar', nativeName: 'Gibraltar', dialCode: '350' },
  { isoCode: 'GR', name: 'Greece', nativeName: 'Ελλάδα', dialCode: '30' },
  { isoCode: 'GL', name: 'Greenland', nativeName: 'Kalaallit Nunaat', dialCode: '299' },
  { isoCode: 'GD', name: 'Grenada', nativeName: 'Grenada', dialCode: '1473' },
  { isoCode: 'GP', name: 'Guadeloupe', nativeName: 'Guadeloupe', dialCode: '590' },
  { isoCode: 'GU', name: 'Guam', nativeName: 'Guam', dialCode: '1671' },
  { isoCode: 'GT', name: 'Guatemala', nativeName: 'Guatemala', dialCode: '502' },
  { isoCode: 'GG', name: 'Guernsey', nativeName: 'Guernsey', dialCode: '44' },
  { isoCode: 'GN', name: 'Guinea', nativeName: 'Guinée', dialCode: '224' },
  { isoCode: 'GW', name: 'Guinea-Bissau', nativeName: 'Guiné-Bissau', dialCode: '245' },
  { isoCode: 'GY', name: 'Guyana', nativeName: 'Guyana', dialCode: '592' },
  { isoCode: 'HT', name: 'Haiti', nativeName: 'Haïti', dialCode: '509' },
  { isoCode: 'HN', name: 'Honduras', nativeName: 'Honduras', dialCode: '504' },
  { isoCode: 'HK', name: 'Hong Kong', nativeName: '香港', dialCode: '852' },
  { isoCode: 'HU', name: 'Hungary', nativeName: 'Magyarország', dialCode: '36' },
  { isoCode: 'IS', name: 'Iceland', nativeName: 'Ísland', dialCode: '354' },
  { isoCode: 'IN', name: 'India', nativeName: 'भारत', dialCode: '91' },
  { isoCode: 'ID', name: 'Indonesia', nativeName: 'Indonesia', dialCode: '62' },
  { isoCode: 'IR', name: 'Iran', nativeName: 'ایران', dialCode: '98' },
  { isoCode: 'IQ', name: 'Iraq', nativeName: 'العراق', dialCode: '964' },
  { isoCode: 'IE', name: 'Ireland', nativeName: 'Éire', dialCode: '353' },
  { isoCode: 'IM', name: 'Isle of Man', nativeName: 'Isle of Man', dialCode: '44' },
  { isoCode: 'IL', name: 'Israel', nativeName: 'ישראל', dialCode: '972' },
  { isoCode: 'IT', name: 'Italy', nativeName: 'Italia', dialCode: '39' },
  { isoCode: 'JM', name: 'Jamaica', nativeName: 'Jamaica', dialCode: '1876' },
  { isoCode: 'JP', name: 'Japan', nativeName: '日本', dialCode: '81' },
  { isoCode: 'JE', name: 'Jersey', nativeName: 'Jersey', dialCode: '44' },
  { isoCode: 'JO', name: 'Jordan', nativeName: 'الأردن', dialCode: '962' },
  { isoCode: 'KZ', name: 'Kazakhstan', nativeName: 'Қазақстан', dialCode: '7' },
  { isoCode: 'KE', name: 'Kenya', nativeName: 'Kenya', dialCode: '254' },
  { isoCode: 'KI', name: 'Kiribati', nativeName: 'Kiribati', dialCode: '686' },
  { isoCode: 'XK', name: 'Kosovo', nativeName: 'Kosovë', dialCode: '383' },
  { isoCode: 'KW', name: 'Kuwait', nativeName: 'الكويت', dialCode: '965' },
  { isoCode: 'KG', name: 'Kyrgyzstan', nativeName: 'Кыргызстан', dialCode: '996' },
  { isoCode: 'LA', name: 'Laos', nativeName: 'ລາວ', dialCode: '856' },
  { isoCode: 'LV', name: 'Latvia', nativeName: 'Latvija', dialCode: '371' },
  { isoCode: 'LB', name: 'Lebanon', nativeName: 'لبنان', dialCode: '961' },
  { isoCode: 'LS', name: 'Lesotho', nativeName: 'Lesotho', dialCode: '266' },
  { isoCode: 'LR', name: 'Liberia', nativeName: 'Liberia', dialCode: '231' },
  { isoCode: 'LY', name: 'Libya', nativeName: 'ليبيا', dialCode: '218' },
  { isoCode: 'LI', name: 'Liechtenstein', nativeName: 'Liechtenstein', dialCode: '423' },
  { isoCode: 'LT', name: 'Lithuania', nativeName: 'Lietuva', dialCode: '370' },
  { isoCode: 'LU', name: 'Luxembourg', nativeName: 'Luxembourg', dialCode: '352' },
  { isoCode: 'MO', name: 'Macau', nativeName: '澳門', dialCode: '853' },
  { isoCode: 'MG', name: 'Madagascar', nativeName: 'Madagasikara', dialCode: '261' },
  { isoCode: 'MW', name: 'Malawi', nativeName: 'Malawi', dialCode: '265' },
  { isoCode: 'MY', name: 'Malaysia', nativeName: 'Malaysia', dialCode: '60' },
  { isoCode: 'MV', name: 'Maldives', nativeName: 'ދިވެހިރާއްޖެ', dialCode: '960' },
  { isoCode: 'ML', name: 'Mali', nativeName: 'Mali', dialCode: '223' },
  { isoCode: 'MT', name: 'Malta', nativeName: 'Malta', dialCode: '356' },
  { isoCode: 'MH', name: 'Marshall Islands', nativeName: 'Marshall Islands', dialCode: '692' },
  { isoCode: 'MQ', name: 'Martinique', nativeName: 'Martinique', dialCode: '596' },
  { isoCode: 'MR', name: 'Mauritania', nativeName: 'موريتانيا', dialCode: '222' },
  { isoCode: 'MU', name: 'Mauritius', nativeName: 'Maurice', dialCode: '230' },
  { isoCode: 'YT', name: 'Mayotte', nativeName: 'Mayotte', dialCode: '262' },
  { isoCode: 'MX', name: 'Mexico', nativeName: 'México', dialCode: '52' },
  { isoCode: 'FM', name: 'Micronesia', nativeName: 'Micronesia', dialCode: '691' },
  { isoCode: 'MD', name: 'Moldova', nativeName: 'Moldova', dialCode: '373' },
  { isoCode: 'MC', name: 'Monaco', nativeName: 'Monaco', dialCode: '377' },
  { isoCode: 'MN', name: 'Mongolia', nativeName: 'Монгол', dialCode: '976' },
  { isoCode: 'ME', name: 'Montenegro', nativeName: 'Crna Gora', dialCode: '382' },
  { isoCode: 'MS', name: 'Montserrat', nativeName: 'Montserrat', dialCode: '1664' },
  { isoCode: 'MA', name: 'Morocco', nativeName: 'المغرب', dialCode: '212' },
  { isoCode: 'MZ', name: 'Mozambique', nativeName: 'Moçambique', dialCode: '258' },
  { isoCode: 'MM', name: 'Myanmar', nativeName: 'မြန်မာ', dialCode: '95' },
  { isoCode: 'NA', name: 'Namibia', nativeName: 'Namibia', dialCode: '264' },
  { isoCode: 'NR', name: 'Nauru', nativeName: 'Nauru', dialCode: '674' },
  { isoCode: 'NP', name: 'Nepal', nativeName: 'नेपाल', dialCode: '977' },
  { isoCode: 'NL', name: 'Netherlands', nativeName: 'Nederland', dialCode: '31' },
  { isoCode: 'NC', name: 'New Caledonia', nativeName: 'Nouvelle-Calédonie', dialCode: '687' },
  { isoCode: 'NZ', name: 'New Zealand', nativeName: 'New Zealand', dialCode: '64' },
  { isoCode: 'NI', name: 'Nicaragua', nativeName: 'Nicaragua', dialCode: '505' },
  { isoCode: 'NE', name: 'Niger', nativeName: 'Niger', dialCode: '227' },
  { isoCode: 'NG', name: 'Nigeria', nativeName: 'Nigeria', dialCode: '234' },
  { isoCode: 'NU', name: 'Niue', nativeName: 'Niue', dialCode: '683' },
  { isoCode: 'NF', name: 'Norfolk Island', nativeName: 'Norfolk Island', dialCode: '672' },
  { isoCode: 'KP', name: 'North Korea', nativeName: '조선', dialCode: '850' },
  { isoCode: 'MK', name: 'North Macedonia', nativeName: 'Северна Македонија', dialCode: '389' },
  {
    isoCode: 'MP',
    name: 'Northern Mariana Islands',
    nativeName: 'Northern Mariana Islands',
    dialCode: '1670'
  },
  { isoCode: 'NO', name: 'Norway', nativeName: 'Norge', dialCode: '47' },
  { isoCode: 'OM', name: 'Oman', nativeName: 'عُمان', dialCode: '968' },
  { isoCode: 'PK', name: 'Pakistan', nativeName: 'پاکستان', dialCode: '92' },
  { isoCode: 'PW', name: 'Palau', nativeName: 'Palau', dialCode: '680' },
  { isoCode: 'PS', name: 'Palestine', nativeName: 'فلسطين', dialCode: '970' },
  { isoCode: 'PA', name: 'Panama', nativeName: 'Panamá', dialCode: '507' },
  { isoCode: 'PG', name: 'Papua New Guinea', nativeName: 'Papua New Guinea', dialCode: '675' },
  { isoCode: 'PY', name: 'Paraguay', nativeName: 'Paraguay', dialCode: '595' },
  { isoCode: 'PE', name: 'Peru', nativeName: 'Perú', dialCode: '51' },
  { isoCode: 'PH', name: 'Philippines', nativeName: 'Pilipinas', dialCode: '63' },
  { isoCode: 'PL', name: 'Poland', nativeName: 'Polska', dialCode: '48' },
  { isoCode: 'PT', name: 'Portugal', nativeName: 'Portugal', dialCode: '351' },
  { isoCode: 'PR', name: 'Puerto Rico', nativeName: 'Puerto Rico', dialCode: '1' },
  { isoCode: 'QA', name: 'Qatar', nativeName: 'قطر', dialCode: '974' },
  { isoCode: 'RE', name: 'Réunion', nativeName: 'La Réunion', dialCode: '262' },
  { isoCode: 'RO', name: 'Romania', nativeName: 'România', dialCode: '40' },
  { isoCode: 'RU', name: 'Russia', nativeName: 'Россия', dialCode: '7' },
  { isoCode: 'RW', name: 'Rwanda', nativeName: 'Rwanda', dialCode: '250' },
  { isoCode: 'WS', name: 'Samoa', nativeName: 'Samoa', dialCode: '685' },
  { isoCode: 'SM', name: 'San Marino', nativeName: 'San Marino', dialCode: '378' },
  {
    isoCode: 'ST',
    name: 'São Tomé and Príncipe',
    nativeName: 'São Tomé e Príncipe',
    dialCode: '239'
  },
  { isoCode: 'SA', name: 'Saudi Arabia', nativeName: 'المملكة العربية السعودية', dialCode: '966' },
  { isoCode: 'SN', name: 'Senegal', nativeName: 'Sénégal', dialCode: '221' },
  { isoCode: 'RS', name: 'Serbia', nativeName: 'Srbija', dialCode: '381' },
  { isoCode: 'SC', name: 'Seychelles', nativeName: 'Seychelles', dialCode: '248' },
  { isoCode: 'SL', name: 'Sierra Leone', nativeName: 'Sierra Leone', dialCode: '232' },
  { isoCode: 'SG', name: 'Singapore', nativeName: 'Singapore', dialCode: '65' },
  { isoCode: 'SX', name: 'Sint Maarten', nativeName: 'Sint Maarten', dialCode: '1721' },
  { isoCode: 'SK', name: 'Slovakia', nativeName: 'Slovensko', dialCode: '421' },
  { isoCode: 'SI', name: 'Slovenia', nativeName: 'Slovenija', dialCode: '386' },
  { isoCode: 'SB', name: 'Solomon Islands', nativeName: 'Solomon Islands', dialCode: '677' },
  { isoCode: 'SO', name: 'Somalia', nativeName: 'Soomaaliya', dialCode: '252' },
  { isoCode: 'ZA', name: 'South Africa', nativeName: 'South Africa', dialCode: '27' },
  { isoCode: 'GS', name: 'South Georgia', nativeName: 'South Georgia', dialCode: '500' },
  { isoCode: 'KR', name: 'South Korea', nativeName: '한국', dialCode: '82' },
  { isoCode: 'SS', name: 'South Sudan', nativeName: 'South Sudan', dialCode: '211' },
  { isoCode: 'ES', name: 'Spain', nativeName: 'España', dialCode: '34' },
  { isoCode: 'LK', name: 'Sri Lanka', nativeName: 'ශ්‍රී ලංකාව', dialCode: '94' },
  { isoCode: 'BL', name: 'St. Barthélemy', nativeName: 'Saint-Barthélemy', dialCode: '590' },
  { isoCode: 'SH', name: 'St. Helena', nativeName: 'Saint Helena', dialCode: '290' },
  {
    isoCode: 'KN',
    name: 'St. Kitts and Nevis',
    nativeName: 'Saint Kitts and Nevis',
    dialCode: '1869'
  },
  { isoCode: 'LC', name: 'St. Lucia', nativeName: 'Saint Lucia', dialCode: '1758' },
  { isoCode: 'MF', name: 'St. Martin', nativeName: 'Saint-Martin', dialCode: '590' },
  {
    isoCode: 'PM',
    name: 'St. Pierre and Miquelon',
    nativeName: 'Saint-Pierre-et-Miquelon',
    dialCode: '508'
  },
  {
    isoCode: 'VC',
    name: 'St. Vincent and Grenadines',
    nativeName: 'Saint Vincent and the Grenadines',
    dialCode: '1784'
  },
  { isoCode: 'SD', name: 'Sudan', nativeName: 'السودان', dialCode: '249' },
  { isoCode: 'SR', name: 'Suriname', nativeName: 'Suriname', dialCode: '597' },
  {
    isoCode: 'SJ',
    name: 'Svalbard and Jan Mayen',
    nativeName: 'Svalbard og Jan Mayen',
    dialCode: '47'
  },
  { isoCode: 'SE', name: 'Sweden', nativeName: 'Sverige', dialCode: '46' },
  { isoCode: 'CH', name: 'Switzerland', nativeName: 'Schweiz', dialCode: '41' },
  { isoCode: 'SY', name: 'Syria', nativeName: 'سوريا', dialCode: '963' },
  { isoCode: 'TW', name: 'Taiwan', nativeName: '臺灣', dialCode: '886' },
  { isoCode: 'TJ', name: 'Tajikistan', nativeName: 'Тоҷикистон', dialCode: '992' },
  { isoCode: 'TZ', name: 'Tanzania', nativeName: 'Tanzania', dialCode: '255' },
  { isoCode: 'TH', name: 'Thailand', nativeName: 'ไทย', dialCode: '66' },
  { isoCode: 'TL', name: 'Timor-Leste', nativeName: 'Timor-Leste', dialCode: '670' },
  { isoCode: 'TG', name: 'Togo', nativeName: 'Togo', dialCode: '228' },
  { isoCode: 'TK', name: 'Tokelau', nativeName: 'Tokelau', dialCode: '690' },
  { isoCode: 'TO', name: 'Tonga', nativeName: 'Tonga', dialCode: '676' },
  {
    isoCode: 'TT',
    name: 'Trinidad and Tobago',
    nativeName: 'Trinidad and Tobago',
    dialCode: '1868'
  },
  { isoCode: 'TN', name: 'Tunisia', nativeName: 'تونس', dialCode: '216' },
  { isoCode: 'TR', name: 'Turkey', nativeName: 'Türkiye', dialCode: '90' },
  { isoCode: 'TM', name: 'Turkmenistan', nativeName: 'Türkmenistan', dialCode: '993' },
  {
    isoCode: 'TC',
    name: 'Turks and Caicos Islands',
    nativeName: 'Turks and Caicos Islands',
    dialCode: '1649'
  },
  { isoCode: 'TV', name: 'Tuvalu', nativeName: 'Tuvalu', dialCode: '688' },
  {
    isoCode: 'VI',
    name: 'U.S. Virgin Islands',
    nativeName: 'U.S. Virgin Islands',
    dialCode: '1340'
  },
  { isoCode: 'UG', name: 'Uganda', nativeName: 'Uganda', dialCode: '256' },
  { isoCode: 'UA', name: 'Ukraine', nativeName: 'Україна', dialCode: '380' },
  {
    isoCode: 'AE',
    name: 'United Arab Emirates',
    nativeName: 'الإمارات العربية المتحدة',
    dialCode: '971'
  },
  { isoCode: 'GB', name: 'United Kingdom', nativeName: 'United Kingdom', dialCode: '44' },
  { isoCode: 'US', name: 'United States', nativeName: 'United States', dialCode: '1' },
  { isoCode: 'UY', name: 'Uruguay', nativeName: 'Uruguay', dialCode: '598' },
  { isoCode: 'UZ', name: 'Uzbekistan', nativeName: "O'zbekiston", dialCode: '998' },
  { isoCode: 'VU', name: 'Vanuatu', nativeName: 'Vanuatu', dialCode: '678' },
  { isoCode: 'VA', name: 'Vatican City', nativeName: 'Città del Vaticano', dialCode: '39' },
  { isoCode: 'VE', name: 'Venezuela', nativeName: 'Venezuela', dialCode: '58' },
  { isoCode: 'VN', name: 'Vietnam', nativeName: 'Việt Nam', dialCode: '84' },
  { isoCode: 'WF', name: 'Wallis and Futuna', nativeName: 'Wallis-et-Futuna', dialCode: '681' },
  { isoCode: 'EH', name: 'Western Sahara', nativeName: 'الصحراء الغربية', dialCode: '212' },
  { isoCode: 'YE', name: 'Yemen', nativeName: 'اليمن', dialCode: '967' },
  { isoCode: 'ZM', name: 'Zambia', nativeName: 'Zambia', dialCode: '260' },
  { isoCode: 'ZW', name: 'Zimbabwe', nativeName: 'Zimbabwe', dialCode: '263' }
];
